import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './utils/auth.interceptor';
import { NgZoneInterceptor } from './utils/ngzone.interceptor';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';
import { FlexLayoutModule } from 'ng-flex-layout';

import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import {MatButtonToggleModule} from '@angular/material/button-toggle';


@NgModule({
  declarations: [
    AppComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    NgxGoogleAnalyticsModule.forRoot('G-YR59R4KWVJ'),
    BrowserAnimationsModule,
    AppRoutingModule,
    FlexLayoutModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatStepperModule,
    MatButtonModule,
    MatIconModule,
    MatButtonToggleModule,
  ],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
    // Duración única para los ~181 puntos donde la app abre un diálogo. Antes no
    // estaba provisto, así que cada apertura caía en el default de Material
    // (150ms al abrir / 75ms al cerrar) salvo dos llamadas sueltas que pedían
    // 400/300 — y como el MISMO EditPatientDialogComponent se abre desde siete
    // lugares distintos, tardaba distinto según desde dónde lo abrieras.
    //
    // Material no escucha animationend: fija --mat-dialog-transition-duration en
    // el host con estos valores y luego espera con setTimeout. O sea que estos
    // dos números son, a la vez, la duración real de la animación CSS y el plazo
    // tras el cual el diálogo se da por abierto o se destruye. Si una animación
    // de salida durara más que exitAnimationDuration, se cortaría a media
    // reproducción — por eso el CSS de _14-dialog-motion se amarra a la variable
    // en vez de traer sus propios tiempos.
    //
    // Los 300ms de entrada no son arbitrarios: las curvas --ease-gel-* están
    // muestreadas sobre esa ventana exacta (ver _02-tokens). Cambiar este número
    // sin regenerarlas deja el resorte sin asentar al cortar, y se ve un salto
    // al final de la apertura.
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { enterAnimationDuration: '300ms', exitAnimationDuration: '180ms' },
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NgZoneInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}